/**
 * Created by lycheng on 2017/12/4.
 * 右边导航
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    difference: 5, // 为了避免top与tops临界点差值过小时，animate不触发的问题
    $container: $('html,body'),
    checkedClass: 'nav-checked'
  },
  init: function () {
    floatMenu.bindEvent()
    floatMenu.methods.rePosition()
  },
  bindEvent: function () {
    $('.js-custom-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target')
      floatMenu.methods.toPosition(target)
    })
    window.onscroll = function () {
      floatMenu.methods.rePosition()
    }
  },
  methods: {
    toPosition: function (target) {
      var top = $('.' + target).offset().top - floatMenu.config.top + floatMenu.config.difference
      floatMenu.config.$container.animate({scrollTop: Math.floor(top)}, 500)
    },
    rePosition: function () {
      var tops = []
      var top = $('body').scrollTop() || $('html').scrollTop()
      var $navCon = $('.js-custom-nav-fall')
      var $navItem = $('.js-custom-nav-fall li')
      var targets = []
      var i = 0
      $navItem.each(function () {
        targets.push($(this).attr('target'))
      })

      for (i = 0; i < targets.length; i++) {
        if ($('.' + targets[i]).offset()) {
          tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top)
        }
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height())

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass)
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass)
        }
      }
      var windowPosition = $(window).scrollTop()
      if (windowPosition >= 300) {
        $navCon.show()
      } else {
        $navCon.hide()
      }
    }

  }
}
floatMenu.init()
export {
  floatMenu
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-topbar-menu.js